import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5541897e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-sm-row justify-content-center align-items-center justify-content-sm-start p-3" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center justify-content-sm-start" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary text-center text-sm-left mb-1"
}
const _hoisted_4 = { class: "d-flex align-items-center justify-content-center justify-content-sm-start" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "m-0 ml-1" }
const _hoisted_8 = { class: "d-flex align-items-center mt-1" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "m-0 ml-1 text-bold text-primary" }
const _hoisted_11 = { class: "px-2" }
const _hoisted_12 = { class: "lead text-bold mb-0" }
const _hoisted_13 = {
  class: "text-preline mb-2",
  style: {"word-break":"break-word"}
}
const _hoisted_14 = {
  class: "text-preline",
  style: {"word-break":"break-word"}
}
const _hoisted_15 = { class: "d-flex flex-wrap align-items-center" }
const _hoisted_16 = { class: "lead mb-0" }
const _hoisted_17 = { class: "px-2" }
const _hoisted_18 = { class: "px-2 position-relative" }
const _hoisted_19 = { class: "d-flex justify-content-between flex-wrap" }
const _hoisted_20 = { class: "d-flex flex-column justify-content-between" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 ml-1" }, "/ 5", -1))
const _hoisted_24 = { class: "lead mb-0" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { class: "review-area" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_29 = { class: "mb-0 lead font-weight-bold" }
const _hoisted_30 = { class: "lead" }
const _hoisted_31 = { class: "text-preline" }
const _hoisted_32 = { class: "px-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-marker shadow-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-briefcase text-primary",
    style: {"font-size":"1.5rem"}
  })
], -1))
const _hoisted_34 = {
  class: "text-preline",
  style: {"word-break":"break-word"}
}
const _hoisted_35 = {
  class: "text-preline",
  style: {"word-break":"break-word"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_GMapMarker = _resolveComponent("GMapMarker")!
  const _component_GMapMap = _resolveComponent("GMapMap")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "expert-personal-info-card mb-3" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Avatar, {
            class: "mr-0 mr-sm-2 mb-2 mb-sm-0 profile-image",
            image: _ctx.expertProfile.imageUrl,
            shape: "circle",
            size: "xlarge"
          }, null, 8, ["image"]),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.expertProfile?.firstName)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.expertProfile?.firstName), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PopoverIcon, {
                "open-delay": 500,
                placement: "right"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "text-bold",
                    innerHTML: _ctx.expertProduct.displayName
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", {
                    innerHTML: _ctx.expertProduct.description
                  }, null, 8, _hoisted_6)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Avatar, {
                    alt: _ctx.expertProduct?.displayName,
                    class: "expert-level",
                    image: _ctx.expertProduct?.iconUrl,
                    shape: "circle"
                  }, null, 8, ["alt", "image"])
                ]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.expertProfile?.function), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("i", {
                class: "pi pi-map-marker text-primary",
                title: _ctx.$t('cart.table.iconLocation_title')
              }, null, 8, _hoisted_9),
              _createVNode(_component_PopoverIcon, {
                "open-delay": 500,
                placement: "right"
              }, {
                content: _withCtx(() => [
                  _createVNode(_component_GMapMap, {
                    center: { lat: _ctx.expertProfile?.latitude, lng: _ctx.expertProfile?.longitude },
                    options: {
										zoomControl: true,
										mapTypeControl: false,
										scaleControl: false,
										streetViewControl: false,
										rotateControl: false,
										fullscreenControl: false,
									},
                    style: {"width":"350px","height":"350px"},
                    zoom: 7
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_GMapMarker, {
                        clickable: false,
                        draggable: false,
                        position: {
											lat: _ctx.expertProfile?.latitude,
											lng: _ctx.expertProfile?.longitude,
										}
                      }, null, 8, ["position"])
                    ]),
                    _: 1
                  }, 8, ["center"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(`${_ctx.expertProfile?.region}, ${_ctx.expertProfile?.country}`), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode(_component_Divider, { class: "m-0" })
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.expertProfile?.shortDescriptionTitle), 1),
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.expertProfile?.shortDescription), 1),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.expertProfile?.description), 1),
          _createVNode(_component_Divider),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(`expert.languages`)) + " :", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertProfile?.spokenLanguages, (language, index) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                key: index,
                class: "p-chip-primary mx-1 mb-1",
                label: language
              }, null, 8, ["label"]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.expertProfile?.expertises?.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "expert-expertises-card mb-3"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t(`expert.expertises`)), 1),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertProfile?.expertises, (expertise, index) => {
                  return (_openBlock(), _createBlock(_component_Chip, {
                    key: index,
                    class: "p-chip-secondary mr-1 mb-1",
                    label: expertise.name
                  }, null, 8, ["label"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.expertProfile?.reviews.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 1,
          class: "expert-reviews-card mb-3"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", null, _toDisplayString(_ctx.$t(`expert.reviews`)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h1", _hoisted_22, _toDisplayString(_ctx.expertProfile.reviewScoreAverage), 1),
                      _hoisted_23
                    ]),
                    _createVNode(_component_Rating, {
                      modelValue: _ctx.expertProfile.reviewScoreAverage,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expertProfile.reviewScoreAverage) = $event)),
                      cancel: false,
                      class: "rating-lg",
                      readonly: true
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$tc("expert.reviewCount", _ctx.expertProfile?.reviews.length)), 1)
                  ])
                ]),
                _createVNode(_component_Chart, {
                  class: "review-chart",
                  data: _ctx.reviewChartData,
                  height: 225,
                  options: _ctx.reviewChartOptions,
                  type: "doughnut",
                  width: 225
                }, null, 8, ["data", "options"])
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedReviews, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_Rating, {
                          modelValue: item.score,
                          "onUpdate:modelValue": ($event: any) => ((item.score) = $event),
                          cancel: false,
                          class: "mr-1",
                          readonly: true
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(item.title), 1)
                      ]),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(item.reviewerDisplayName) + " - " + _toDisplayString(_ctx.formatElapsedTime(item.date)), 1),
                      _createElementVNode("p", _hoisted_31, _toDisplayString(item.comment), 1),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expertProfile?.reviewTags[item.id], (expertise, index) => {
                          return (_openBlock(), _createBlock(_component_Chip, {
                            key: index,
                            class: "p-chip-secondary mr-1 mb-1",
                            label: expertise
                          }, null, 8, ["label"]))
                        }), 128))
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.expertProfile?.experiences?.length)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 2,
          class: "expert-experience-card mb-3"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t(`expert.experience`)), 1),
              (!_ctx.isSmallScreen)
                ? (_openBlock(), _createBlock(_component_Timeline, {
                    key: 0,
                    align: _ctx.expertProfile?.experiences?.length > 1 ? 'alternate' : 'left',
                    value: _ctx.expertProfile?.experiences
                  }, {
                    marker: _withCtx(() => [
                      _hoisted_33
                    ]),
                    content: _withCtx((slotProps) => [
                      _createVNode(_component_Card, { class: "mb-2 ml-2 experience-card" }, {
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(slotProps.item.title), 1)
                        ]),
                        subtitle: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${slotProps.item.company} ${_ctx.getExperienceDate(
										slotProps.item.experienceStartDate,
										slotProps.item.experienceEndDate
									)}`), 1)
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(slotProps.item.description), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["align", "value"]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.expertProfile?.experiences, (experience) => {
                    return (_openBlock(), _createBlock(_component_Card, {
                      key: experience.id,
                      class: "mb-2 experience-card"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(experience.title), 1)
                      ]),
                      subtitle: _withCtx(() => [
                        _createTextVNode(_toDisplayString(`${experience.company} ${_ctx.getExperienceDate(
									experience.experienceStartDate,
									experience.experienceEndDate
								)}`), 1)
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("p", _hoisted_35, _toDisplayString(experience.description), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}